const DEFAULT_FALLBACK = '-';

export const formatDisplayValue = (value: string | number | null | undefined, fallback = DEFAULT_FALLBACK): string => {
  if (value === null || value === undefined) {
    return fallback;
  }

  if (typeof value === 'string' && value.trim() === '') {
    return fallback;
  }

  return String(value);
};
